const columns = [
  {
    header: 'Type',
    field: 'type',
    sortable: true,
  },
  {
    header: 'Employee ID',
    field: 'employeeId',
    sortable: true,
  },
  {
    header: 'Person ID',
    field: 'PERSONID',
    sortable: true,
  },
  {
    header: 'Endorsement ID',
    field: 'endorsementId',
    sortable: true,
  },
  {
    header: 'Status',
    field: 'status',
    sortable: true,
  },
  {
    header: 'Status Description',
    field: 'statusDescription',
    sortable: true,
  },
  {
    header: 'Affected Date',
    field: 'affectedDate',
    sortable: true,
  },
  {
    header: 'Created Date',
    field: 'createdDate',
    sortable: true,
  },
  {
    header: 'Updated Date',
    field: 'updatedDate',
    sortable: true,
  },
  // Every row action in one column, so a row shows only what applies to it
  // instead of a run of mostly empty columns.
  {
    header: 'Actions',
    field: 'actions',
  },
];

export default columns;
